// src/pages/fiscal/mdfe/CadastroFiscalSearch.js
import React, { useMemo, useState } from 'react';

import ModalBody from '../../../components/modalForm/ModalBody';
import ModalContainer from '../../../components/modalForm/ModalContainer';
import ModalFooter from '../../../components/modalForm/ModalFooter';
import ModalHeader from '../../../components/modalForm/ModalHeader';
import ModalTable from '../../../components/modalForm/ModalTable';
import LazyLoading from '../../../components/modalForm/LazyLoading';

import { normalizeText } from '../../../utils/stringUtils';
import ModalSearchBar from '../../../components/modalForm/ModalSearchBar';
import { ModalActionButton } from '../../../components/modalForm/ModalActions';
import ModalSelectButton from '../../../components/modalForm/ModalSelectButton';

const CadastroFiscalSearch = ({ show, onHide, titulo, registros, campos, onSelect }) => {
  const labels = { placa: 'Placa', renavam: 'RENAVAM', uf: 'UF', nome: 'Nome', cpf: 'CPF', cnpj: 'CNPJ' };
  const [filtro, setFiltro] = useState('');

  const filtrados = useMemo(() => registros.filter((item) =>
    campos.some((campo) => normalizeText(item[campo] ?? '').includes(normalizeText(filtro))),
  ), [registros, campos, filtro]);

  return (
    <ModalContainer show={show} largura="850px" zIndex={1060} variant="busca" onHide={onHide}>
      <ModalHeader title={titulo} onHide={onHide} />
      <ModalBody>
        <ModalSearchBar  value={filtro} onChange={(e) => { setFiltro(e.target.value);  }} placeholder="Pesquisar..." />
        <LazyLoading items={filtrados} resetKey={JSON.stringify([show, filtro])}>
        {({ containerRef, handleScroll, visibleItems }) => (
        <ModalTable containerRef={containerRef} onContainerScroll={handleScroll}>
          <thead><tr>{campos.map((campo) => <th key={campo}>{labels[campo] || campo}</th>)}<th>Ativo</th><th className="modal-select-column">Selecionar</th></tr></thead>
          <tbody>
            {visibleItems.map((item) => (
              <tr key={item.id} onDoubleClick={() => onSelect(item)}>
                {campos.map((campo) => <td key={campo}>{item[campo]}</td>)}
                <td>{item.ativo ? 'Sim' : 'Não'}</td>
                <td className="modal-select-column">
                  <ModalSelectButton type="button" className="btn btn-outline-primary btn-sm" onClick={() => onSelect(item)} label={item.nome || item.placa || item.id} />
                </td>
              </tr>
            ))}
          </tbody>
        </ModalTable>
        )}
        </LazyLoading>
      </ModalBody>
      <ModalFooter>

        <ModalActionButton type="button" className="btn btn-secondary" onClick={onHide} action="close">Fechar</ModalActionButton>
      </ModalFooter>
    </ModalContainer>
  );
};

export default CadastroFiscalSearch;
